import { connect } from 'react-redux';
import AuctionsWrap from 'components/auctions/AuctionsWrap';
import {
  clearAuctions,
  clearAuctionBids,
  clearAuctionsGridPage,
  clearAuctionHistory,
  setAuctionsGridPage,
} from 'data/auctions/Auctions.actions';

const mapStateToProps = state => ({
  pageNo: state.auctions.pageNo,
});

const mapDispatchToProps = dispatch => ({
  clearAuctions: () => {
    dispatch(clearAuctions());
    dispatch(clearAuctionBids());
    dispatch(clearAuctionsGridPage());
    dispatch(clearAuctionHistory());
  },
  setGridPage: pageNo => dispatch(setAuctionsGridPage(pageNo)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AuctionsWrap);
